import { render, staticRenderFns } from "./InputSelectMultiDeAggrid.vue?vue&type=template&id=987f81f0&scoped=true"
import script from "./InputSelectMultiDeAggrid.vue?vue&type=script&lang=js"
export * from "./InputSelectMultiDeAggrid.vue?vue&type=script&lang=js"
import style0 from "./InputSelectMultiDeAggrid.vue?vue&type=style&index=0&id=987f81f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "987f81f0",
  null
  
)

export default component.exports